import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function cursoTipoComboReducer(state= initialState.cursoTipoCombo, action){
	switch(action.type){
		case types.GET_CURSOS_TIPO_COMBO_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}